<template>
  <div
    :id="`${source}_info_stat`"
    class="flex flex-col gap-1 proxima_nova text_color"
  >
    <div class="flex flex-row items-center gap-1">
      <span v-if="data?.title" class="text-[13px] secondary_color">{{
        data?.title
      }}</span>

      <a-tooltip
        v-if="data?.description"
        :placement="alignment"
        color="var(--tooltip-bg)"
      >
        <template #title>
          {{ data?.description }}
        </template>

        <ThemeImage class="size-3" :icon="imageNames.INFO_GREY" alt="info_icon" />
      </a-tooltip>
    </div>

    <span v-if="data?.value" class="text-2xl font-semibold">{{
      data?.value
    }}</span>
  </div>
</template>

<script setup>

import {imageNames} from "@/src/constants/imageConstants.js";

const props = defineProps({
  source: { type: String, required: true },
  data: { type: Object, required: true },
  alignment: { type: String, default: "top" },
});
</script>
